import { render } from "./VideoComments.vue?vue&type=template&id=07cd4f70&scoped=true"
import script from "./VideoComments.vue?vue&type=script&lang=js"
export * from "./VideoComments.vue?vue&type=script&lang=js"

import "./VideoComments.vue?vue&type=style&index=0&id=07cd4f70&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cd4f70"]])

export default __exports__